import _ from 'lodash';
import dfsSearch from './dfsSearch';
import { getObject } from './mapObject';
import { UWEEntity } from '../api/types';
import Jnx from './jnx';
import { JSONSchema } from './jsonschemaTypes';

function transformJsonSchema(schema: JSONSchema, entity?: UWEEntity) {
  const newSchema: any = _.cloneDeep(schema);
  const excludedSchemaProps: Record<string, boolean> = {};

  dfsSearch([['', newSchema, null]], ([prop, current, parent]) => {
    if (current.$$include) {
      const includePath = current.$$include.split('#/')[1].replace(/\//g, '.');
      const ref = getObject(newSchema, includePath);
      delete current.$$include;
      const clone = JSON.parse(JSON.stringify(current));
      _.merge(current, ref, clone);
    }

    if (current[':classNames']) {
      current['ui:classNames'] = current[':classNames'];
    }

    if (current['enum'] && current['enumNames']) {
      const namesByEnum: Record<string, string> = {};
      current['enum'].forEach((e: string, ix: number) => {
        namesByEnum[e] = current['enumNames'][ix];
      });
      current['ui:enumNames'] = namesByEnum;
    }

    const { required, isRequired } = current;

    if ((required || isRequired) && parent && prop) {
      if (!parent.required) parent.required = [];
      parent.required.push(prop);
    }

    if (current['ui:staticShowIf']) {
      const jnx = new Jnx(current['ui:staticShowIf']);
      const show = jnx.eval({}, '', { formObject: entity });
      if (!show) {
        excludedSchemaProps[prop] = true;
      }
    }

    switch (current.type) {
      case 'object':
        return Object.entries(current.properties).map(([prop, propSchema]) => [prop, propSchema, current]);
      case 'array':
        return [['', current.items, current]];
    }
  });

  const filteredSchema = deepOmitBy(newSchema, (v, k) => {
    return excludedSchemaProps[k] ?? false;
  });

  return filteredSchema;
}

function deepOmitBy<T>(value: T, predicate: (val: any, key: string) => boolean): any {
  // Handle Arrays: Map through items and recurse
  if (_.isArray(value)) {
    return value.map(item => deepOmitBy(item, predicate));
  }

  // Handle Plain Objects: Omit top-level then recurse into values
  if (_.isPlainObject(value)) {
    const omitted = _.omitBy(value as object, predicate);
    return _.mapValues(omitted, v => deepOmitBy(v, predicate));
  }

  // Return primitives as-is
  return value;
}

export default transformJsonSchema;
